import { FormSubmission, Form, AssessmentKeys } from '@uplift/types';
import { restClient } from '../../client';

export type AssessmentSubmission = {
  score: number;
  score_diff_percentage?: number;
  submission: FormSubmission;
};

export type AssessmentSubmissionsOutput =
  | { error: string }
  | {
    submissions: AssessmentSubmission[];
  };

export const getAllFormSubmissions = (formKey: string, patientId: string) =>
  restClient.request<AssessmentSubmissionsOutput>('/api/v1/form/submissions', {
    method: 'POST',
    data: {
      patient_id: patientId,
      form_key: formKey
    }
  });


export const getBatchAssessmentSubmissions = (patientId: string, submissionIds: string[]) =>
  restClient.request<{ data: { submissions: AssessmentSubmission[]; forms: Form[]; form_id_to_key: {form_id: string; key: AssessmentKeys}[] } }>('/api/v1/form/batch-assessment-submission', {
    method: 'POST',
    data: {
      patient_id: patientId,
      submission_ids: submissionIds
    }
  });
